import { Injectable, inject } from '@angular/core';
import { AuthenticationActions } from '@navfleet/client/authentication/domain/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { UserApi } from '../api/user.api';
import { UserActions } from './user.actions';

@Injectable()
export class UserEffects {
    private actions$ = inject(Actions);
    private api = inject(UserApi);

    public readonly loadUsersOnLogin$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthenticationActions.loginSuccess),
            map(() => UserActions.loadUsers())
        )
    );

    public readonly loadUsers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserActions.loadUsers),
            concatMap(() =>
                this.api.getUsers().pipe(
                    map((users) => UserActions.loadUsersSuccess({ users })),
                    catchError((error) => of(UserActions.loadUsersFailure({ error })))
                )
            )
        )
    );
}
